import { openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5a2bde1a")

_pushScopeId("data-v-5a2bde1a")
const _hoisted_1 = { class: "responsive-embed" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock("iframe", {
      key: _ctx.url,
      ref: "iframeRef",
      frameborder: "0",
      src: _ctx.url
    }, null, 8, ["src"]))
  ]))
})